import { useNavigate } from 'react-router-dom';
import { EmptyState, NoResultsArt } from '@/components/ui/EmptyState';
import { Button } from '@/components/ui/Button';
import { AppBar } from '@/components/ui/AppBar';

export function NotFoundScreen() {
  const navigate = useNavigate();

  return (
    <>
      <AppBar back title="Not found" />
      <EmptyState
        illustration={<NoResultsArt />}
        title="That page has moved"
        body="The link may be old, or the product may no longer be listed by any pharmacy near you."
        action={
          <Button full onClick={() => navigate('/')}>
            Back to home
          </Button>
        }
        secondaryAction={
          <Button full variant="grey" onClick={() => navigate('/search')}>
            Search medicines
          </Button>
        }
      />
    </>
  );
}
